/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/executiveMaster.js
 *
 * Description:
 * Executive related master data used by Installed Product Management.
 *
 * NOTE:
 * These are frontend static masters.
 * Later they will be replaced by Master APIs.
 * ============================================================================
 */

/* ============================================================================
 * EXECUTIVE TYPES
 * ========================================================================== */

export const EXECUTIVE_TYPES = [
    { value: "", label: "Select" },
    { value: "KGD", label: "KGD Executive" },
    { value: "JAKSON", label: "Jakson Executive" },
   // { value: "DEALER", label: "Dealer Representative" },
   // { value: "CUSTOMER", label: "Customer Representative" },
    { value: "OTHER", label: "Other" }
];

/* ============================================================================
 * EXECUTIVE MASTER
 * ========================================================================== */

export const EXECUTIVE_MASTER = {

    KGD: [
        "AJ Brothers & Company",
        "Aadeo Techsol Private Limited",
        "ABS Power Solutions",
        "Agarwal & Associate Engineers",
        "Aligarh Power Point",
        "Bajrang Agencies",
        "Balaji Auto Electric Centre",
        "Bhaskar India Greater",
        "Bhutan Power System",
        "Braj Machines",
        "BSES India Pvt. Ltd.",
        "Buddha Power",
        "Bull Power Energy Pvt. Ltd.",
        "Divyanshi Power Solution",
        "DNM Sales",
        "DNM Services",
        "Elecmech Solutions",
        "Elemech International Pvt. Ltd. (Eipl)",
        "ESEN Engineers",
        "Ganga Generator Trading",
        "Global Vision Power Solutions Pvt. Ltd.",
        "Grover Electrical Engineering Works",
        "Integrated Genset India (P) Ltd",
        "Jamtsho Sales Phuentsholing",
        "Jexxa Pawerex India Pvt Ltd",
        "Kamal Enterprises",
        "Kay Gee Engineers",
        "Kesharichand Bhanwarlall",
        "Kiran Electric & Rewinding Work",
        "Krabhi Tech",
        "Kumar Generator House",
        "MS Trade International",
        "Maa Sharda Machinery Stores",
        "Matsya Diesel Sales & Service",
        "Mehrotra & Company",
        "Mittal Machinery Store",
        "NK Enterprises",
        "Neo Tech Corporation",
        "Om Sai Traders",
        "Optimus Energy & Services",
        "Pal Engineering Services",
        "Power Solutions",
        "PSG Electricals Pvt Ltd",
        "Punjab Diesel",
        "RD Power Solution",
        "Rank Solutions Services",
        "Rudra Power",
        "SM Brothers",
        "SAM Engineering",
        "Sangam Power Solutions",
        "Shanvi Enterprises",
        "Shreedhar Electricals",
        "Shuvakamal Global Business Hub Pvt. Ltd.",
        "United Power Solution",
        "Vantage Air Solutions",
        "Vindhyeshwari Enterprises",
        "Vishal Trade Links",
        "Western India Corporation (New)"
    ],

    JAKSON: [
        "Narendra Sharma",
        "Satish Kumar",
        "Devesh Narayan Sharma",
        "Maithli Sharma",
        "Sorav Singh",
        "Rajeev Mathur",
        "Pawan Sahni",
        "GS Pathania",
        "Parwez Shahidi",
        "Vivek Shingari",
        "Kunwar Singh",
        "Hariom Saxena",
        "RP Balyan",
        "Amit Kumar Sharma",
        "Ankit Kumar",
        "Manish Mishra",
        "Sanjay Sharma",
        "Shakti Shukla",
        "Ranvir Mishra",
        "Mohit Gaur",
        "Anil Gautam",
        "Hemant Gupta",
        "Trilok Sharma",
        "Rajendra Sharma",
        "Manish Jangid",
        "Jitendra Gajja",
        "Sandeep Parihar",
        "AN Shukla",
        "Nitin Gautam",
        "RK Sinha",
        "Vipin Singh",
        "Ashutosh Sharma",
        "Darshan Dhingra",
        "Vincy Dassi",
        "Chitrapal Singh",
        "Arvind Singh Negi",
        "Shivam Nag",
        "Vikas Sharma",
        "Chandan Mishra",
        "Naushad Hussain",
        "Sachin Sharma",
        "Ankit Sokariya",
        "Sumit Sood"
    ],

    DEALER: [],

    CUSTOMER: [],

    OTHER: [
        "GOEL Power",
        "Stock Transfer"
    ]
};
/* ============================================================================
 * HELPER METHODS
 * ========================================================================== */

/**
 * Returns executive names for the selected executive type.
 */
export const getExecutiveNames = (executiveType) => {

    if (!executiveType) {
        return [{ value: "", label: "Select" }];
    }

    const names = EXECUTIVE_MASTER[executiveType] || [];

    return [
        { value: "", label: "Select" },

        ...names.map(name => ({
            value: name.toUpperCase().replace(/\s+/g, "_"),
            label: name
        })),

        { value: "NA", label: "NA" }
    ];
};